import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DesktopHeaderComponent } from 'src/app/general-components/desktop-header/desktop-header.component';
import { PackOverviewComponent } from 'src/app/general-components/pack-overview/pack-overview.component';

@Component({
  selector: 'app-packs',
  templateUrl: './packs.page.html',
  styleUrls: ['./packs.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    DesktopHeaderComponent,
    PackOverviewComponent
  ]
})
export class PacksPage {

}
